export enum EYesNo {
  Yes = 'Yes',
  No = 'No',
}
